<template>
  <!--====================  blog grid area ====================-->
  <div class="blog-grid-area section-space--inner--120" :class="addClass">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <!-- section title -->
          <div class="section-title-area text-center">
            <h2 class="section-title section-space--bottom--50">
              <!-- {{ data.sectionTitle }}<span class="title-icon"></span> -->
              بلاگ<span class="title-icon"></span>
            </h2>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="blog-grid-wrapper">
            <div class="row">
              <div
                class="col-lg-4 col-md-6"
                v-for="news in getLatestNews"
                :key="news.id"
              >
                <BlogPost :blog="news" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--====================  End of blog grid area  ====================-->
</template>

<script>
import BlogPost from "../BlogPost"
// import data from "../../data/blog.json"
import { newsStore } from "@/store/Modules/news.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  components: {
    BlogPost,
  },
  props: ["addClass"],
  data() {
    return {
      // data,
    }
  },
  mounted() {
    this.getLatestNewsAction(1, 3)
  },
  computed: {
    ...mapState(newsStore, ["getLatestNews"]),
  },
  methods: {
    ...mapActions(newsStore, ["getLatestNewsAction"]),
  },
}
</script>

<style lang="scss"></style>
